import * as React from 'react';
import { connect } from 'react-redux';
import './PropertyRating.css';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import { ISelectableTile } from '../../../../interfaces/KPSelectableTile/KPSelectableTileInterfaces';
import KPSelectableTileContainer from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableTile/KPSelectableTileContainer';
import { postToController } from '../../../../actions/apiActions';
import { BUILDING_FINISH_ABOVE_AVERAGE_ID, BUILDING_FINISH_HIGH_ID, BUILDING_FINISH_STANDARD_ID } from '../../../../constants/constants';

class PropertyRating extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            items: [],
            selectedOption: this.props.sales.buildingRating ?? "",
            submitted: false,
            nextDisabled: false
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.getListDataSet = this.getListDataSet.bind(this);
    }

    componentWillMount() {
        this.checkSubmit();
        this.getListDataSet();
    }

    checkSubmit() {
        this.setState({ nextDisabled: !(this.state.selectedOption !== "") });
    }

    async getListDataSet(){
        let dataSet: ISelectableTile[] = [];
        await postToController(this.props.dispatch, 'GetBuildingFinishes', JSON.stringify({})).then(async (response) => {
            response.forEach((item, index) => {
                switch (item.id) {
                    case BUILDING_FINISH_STANDARD_ID:
                        dataSet.push({
                            id: "item" + item.id,
                            value: item.id,
                            tileImage: "./Images/BuildingAndHomeContent/standard-rating.svg",
                            title: item.description,
                            body: "By 'standard' we mean the typical or expected finishes you would find in a building, based on the type of building, its style, and value.",
                            selected: (this.props.sales.buildingRating === item.id),
                            handleSelect: null,
                            className: "",
                            colClassName: "col-md-4"
                        } as ISelectableTile);
                        break;
                    case BUILDING_FINISH_ABOVE_AVERAGE_ID:
                        dataSet.push({
                            id: "item" + item.id,
                            value: item.id,
                            tileImage: "./Images/BuildingAndHomeContent/above-rating.svg",
                            title: item.description,
                            body: "Above-average finishes are used to create a more sophisticated look and feel in a home and can increase its value and market appeal.",
                            selected: (this.props.sales.buildingRating === item.id),
                            handleSelect: null,
                            className: "",
                            colClassName: "col-md-4"
                        } as ISelectableTile);
                        break;
                    case BUILDING_FINISH_HIGH_ID:
                        dataSet.push({
                            id: "item" + item.id,
                            value: item.id,
                            tileImage: "./Images/BuildingAndHomeContent/renting-income.svg",
                            title: item.description,
                            body: "This includes features such as high ceilings, crown moulding, detailed trim work, and advanced tech like smart home and energy-efficient systems.",
                            selected: (this.props.sales.buildingRating === item.id),
                            handleSelect: null,
                            className: "",
                            colClassName: "col-md-4"
                        } as ISelectableTile);
                        break;
                    default:
                        break;
                }
            });
        });

        this.setState({ items: dataSet });
    }

    handleItemSelect(id: string, selected: boolean) {
        let item = this.state.items.filter(x => x.id === id)[0];
        this.setState({ selectedOption: item.value }, () => this.checkSubmit());
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            this.props.dispatchAction(setQuoteData({ buildingRating: this.state.selectedOption }));
            await this.props.dispatchAction(handleNextStep());
        }
    }

    public render() {
        return (
            <div className="container">
                <div className="mt-4 text-center">
                    How would you rate the fixed finishings in your home (like the lights, cupboards, tiles, taps, sanitary ware, and fitted carpets)?
                </div>
                {this.state.items.length > 0 &&
                    <div className="mt-4">
                        <KPSelectableTileContainer
                            radioGroup={true}
                            items={this.state.items}
                            handleSelect={this.handleItemSelect}
                        />
                    </div>
                }

                <div className="row mt-4">
                    <div className="col-12 justify-content-center mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertyRating);